import "./HireUs.css";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import HireUsComponets from "./HireUsComponets/HireUsComponets";

const HireUs = () => {
  return (
    <div className="HireUs">
      <NavBar />
      <HireUsComponets />
      <Footer />
    </div>
  );
};

export default HireUs;
